/**
 * Данные рождения и формы программ в браузере — их стирает выход из
 * аккаунта (lib/auth.js logout, 14.10.2026). Раньше выход убирал только
 * токен, и следующему гостю за тем же браузером подставлялись чужие дата,
 * время и город рождения (и имя из нумерологии).
 *
 * Здесь всё, что страницы кладут в хранилище из формы человека и читают
 * обратно, чтобы её заполнить. Метки визита, рефкод, устройство и
 * служебные отметки оплаты не трогаем — к данным рождения они не относятся.
 */
export const BIRTH_DATA_LOCAL_KEYS = [
  'astrofeel_natal_form', // форма натальной карты на главной (с именем)
  'birthData', 'transitData', 'transitCalculatedOn', // «События на день»
  'money_v2_form', 'mum_v2_form', 'women_v2_form', 'women_v2_resume',
  'num_v2_form', 'obraz_v2_form', 'month_v2_form', 'chakry_form',
  'chakry_para_form', 'work_v2_form', 'uzel_v2_form', 'vlyubit_form', 'vlyubit_resume',
  'para_return_pair', 'chakry_return', 'calc_unlock_return', 'calc_unlock_return_path',
  'horary_draft', 'horary_city', 'horary_impulse',
  'lunar_today_city',
  'promo_bar_status',
];

export const BIRTH_DATA_SESSION_KEYS = [
  'astrofeel_last_chart', 'daily_aspect_anchor', 'natal_preview_sent', 'promo_bar_status',
];

export function clearBirthDataStorage() {
  BIRTH_DATA_LOCAL_KEYS.forEach((k) => {
    try { localStorage.removeItem(k); } catch (_e) { /* хранилище недоступно */ }
  });
  BIRTH_DATA_SESSION_KEYS.forEach((k) => {
    try { sessionStorage.removeItem(k); } catch (_e) { /* хранилище недоступно */ }
  });
}
